import { render, staticRenderFns } from "./RoundInfo.vue?vue&type=template&id=3081e127&scoped=true&"
import script from "./RoundInfo.vue?vue&type=script&lang=js&"
export * from "./RoundInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoundInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RoundInfo.vue?vue&type=style&index=1&id=3081e127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081e127",
  null
  
)

export default component.exports